import React from 'react';
import PropTypes from 'prop-types';
import { Pill, RadioButtons } from 'DesignSystem';
import UploadTypes from 'Upload/UploadTypes';

const FullWidthUploadPanelRadioButtons = (props) => {
  const options = [
    {
      defaultChecked: true,
      text: 'I want to edit my PDF only',
      value: UploadTypes.FreeWrite,
    },
    {
      defaultChecked: false,
      text: 'I want to edit my PDF & rearrange pages',
      value: UploadTypes.Rearrange,
    },
  ];

  if (props.isTemplateOptionAvailable) {
    const newOptionPill = (
      <Pill
        className="template-option-pill"
        type="alt"
      >
        NEW
      </Pill>
    );

    options.push(
      {
        children: newOptionPill,
        defaultChecked: false,
        text: 'I want to add fillable fields to my PDF for someone else to fill out',
        value: UploadTypes.Template,
      },
    );
  }

  const onChange = (e) => {
    switch (e.target.value) {
      case UploadTypes.FreeWrite:
        props.pdfOnlyClick();
        break;
      case UploadTypes.Rearrange:
        props.rearrangePagesClick();
        break;
      case UploadTypes.Template:
        props.templateOptionClick();
        break;
      default:
        break;
    }
  };

  return (
    <RadioButtons
      className="upload-type-radio-buttons"
      id="uploadType"
      onChange={onChange}
      options={options}
    />
  );
};

FullWidthUploadPanelRadioButtons.defaultProps = {
  isTemplateOptionAvailable: false,
  templateOptionClick: null,
};

FullWidthUploadPanelRadioButtons.propTypes = {
  isTemplateOptionAvailable: PropTypes.bool,
  pdfOnlyClick: PropTypes.func.isRequired,
  rearrangePagesClick: PropTypes.func.isRequired,
  templateOptionClick: PropTypes.func,
};

export default FullWidthUploadPanelRadioButtons;



// WEBPACK FOOTER //
// ./src-react/EditPDFLandingPage/FullWidthUploadPanelRadioButtons.jsx